/* Headless CMS */
import {
  ContentItem,
  Elements,
  TypeResolver,
  DeliveryClient
} from '@kentico/kontent-delivery';

const deliveryClient = new DeliveryClient({
  projectId: process.env.VUE_APP_PROJECTID,
});

export { deliveryClient };
